import React from "react";

export const LogoMark = ({ className = "", size = 40 }) => (
  <img
    src="/volt-pdr-logo.webp"
    alt="VOLT-PDR"
    width={size}
    height={size}
    className={className}
    style={{ objectFit: "contain" }}
  />
);

export const Logo = ({ compact = false }) => (
  <img
    src="/volt-pdr-logo.webp"
    alt="VOLT-PDR Electric Technology"
    className="w-auto object-contain"
    style={{ height: compact ? 40 : 112 }}
  />
);
